import ChooseLanguage from './ChooseLanguage';

export default {
  'language': {
    screen: ChooseLanguage,
    expanded:true
  },
};
